var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeBaseNew2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.455,
    height: 18,
    viewBox: "0 0 62.455 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-base-new-2",
    transform: "translate(-193.764 -541.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-base-new2",
    transform: "translate(193.764 541.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M4.679,7.6s5.58-4.214,10.1-4.371,9.551,3.08,9.551,3.08a10.959,10.959,0,0,0-.684-2.325c-.259-.56-.711-.722-1.132-1.1A9.953,9.953,0,0,0,19.793.876C18.7.424,16.988.686,15.451.733a13.158,13.158,0,0,0-4.99.807A12.026,12.026,0,0,0,6.114,4.274,8.216,8.216,0,0,0,4.679,7.6Z",
    transform: "translate(-4.246 -0.615)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M22.867,4.614,23.6,7.547s-4.652-4.085-9.66-4.341S3.574,6.524,3.574,6.524A18.084,18.084,0,0,1,4.882,3.947c.637-.944.345-.4,1.241-1.2A10.941,10.941,0,0,1,8.97.873C10.054.425,11.755.685,13.28.732a13.1,13.1,0,0,1,4.955.8A16.8,16.8,0,0,1,22.867,4.614Z",
    transform: "translate(38.415 -0.615)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M5.762,3.388A20.6,20.6,0,0,0,14.43,6.036c4.523.157,9.551-3.08,9.551-3.08s1.292,3.846-.894,5.7S16.54,11.1,15,11.05C13.348,11,7.6,10.956,5.232,9.223c-1.22-.893-1.569-3.467-1.195-4.71C4.289,3.661,5.762,3.388,5.762,3.388Z",
    transform: "translate(-3.895 6.608)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M22.581,3.74a20.6,20.6,0,0,1-8.668,2.648C9.39,6.544,4.634,3.74,4.634,3.74S3.07,7.153,5.256,9.012s6.548,2.437,8.084,2.39c1.655-.051,7.4-.095,9.771-1.828,1.22-.893,1.569-3.467,1.195-4.71C24.054,4.012,22.581,3.74,22.581,3.74Z",
    transform: "translate(38.006 6.257)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eyes",
    transform: "translate(195.088 541.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M15.014,1.011c2.239.635,4.324,3.458,4.324,3.458s-2.558-2.6-4.177-3.044-6.56.038-8.209.338S1.185,5.086,1.185,5.086,4.35,1.95,6.805,1.424,12.774.376,15.014,1.011Z",
    transform: "translate(-1.185 -0.719)",
    fill: "#75798c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M9.18,1.67c4.716,0,9.958-3.545,9.958-3.545S13.9.781,9.18.781A18.245,18.245,0,0,1,.687-1.493,14.811,14.811,0,0,0,9.18,1.67Z",
    transform: "translate(-0.149 11.743)",
    fill: "#75798c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(41.138 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M5.509,1.011C3.27,1.646,1.185,4.468,1.185,4.468s2.558-2.6,4.177-3.044,6.56.038,8.209.338,5.767,3.324,5.767,3.324-3.165-3.136-5.62-3.662S7.748.376,5.509,1.011Z",
    transform: "translate(-0.431 -0.719)",
    fill: "#75798c",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M10.062,1.83C5.347,1.83.1-1.519.1-1.519S5.347.941,10.062.941a15.605,15.605,0,0,0,8.065-2.274A12.86,12.86,0,0,1,10.062,1.83Z",
    transform: "translate(-0.097 11.583)",
    fill: "#75798c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBaseNew2);
export default __webpack_public_path__ + "static/media/eye-base-new-2.94bce10d42dd7b809c921d15d6b2a43e.svg";
export { ForwardRef as ReactComponent };